import { Component, Input, OnChanges, OnInit } from '@angular/core';
import {
  IoniconsOutline,
  LoggedUser,
  NavItem,
  NavItemsId,
} from '@pt/pt-models';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { LocalStorageService, PtCoreActions, UrlUtils } from '@pt/pt-core';
import { TranslateService } from '@ngx-translate/core';
import {
  isActiveMicrosoftModule,
  isExternalUserManagement,
  loginResponse,
  organization,
} from '../../../../../../pt-core/src/lib/store/selectors/pt-core.selectors';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Organization } from 'it/primatoo/openapi/api/org/schemas/organization/Organization';

@UntilDestroy()
@Component({
  selector: 'pt-navbar-user-item',
  template: `
    <div
      ngbDropdown
      display="dynamic"
      placement="bottom-end"
      #dropdown="ngbDropdown"
    >
      <button class="btn btn-sm btn-user" ngbDropdownToggle>
        <pt-icon [key]="IconUser"></pt-icon>
      </button>
      <div ngbDropdownMenu class="dropdown-menu user-dropdown-menu">
        <pt-navbar-user-item-layout
          [name]="name"
          [surname]="surname"
          [system]="system"
          [admin]="admin"
          [username]="username"
          [orgName]="orgName"
          [email]="email"
          [isMicrosoftModule]="isActiveMicrosoftModule$ | async"
          [isExternalUserManagement]="isExternalUserManagement$ | async"
          (clickProfile)="clickItem(profile); dropdown.close()"
          (clickSignOut)="clickSignOut(signOut); dropdown.close()"
        >
        </pt-navbar-user-item-layout>
      </div>
    </div>
  `,
  styleUrls: [`navbar-user-item.component.scss`],
})
export class NavbarUserItemComponent implements OnInit, OnChanges {
  @Input() item: NavItem;

  organization$: Observable<Organization> = this.store.select(organization);
  user$: Observable<LoggedUser> = this.store.select(loginResponse);
  isActiveMicrosoftModule$: Observable<boolean> = this.store.select(
    isActiveMicrosoftModule
  );

  isExternalUserManagement$: Observable<boolean> = this.store.select(
    isExternalUserManagement
  );
  org?: Organization;
  user?: LoggedUser;

  signOut: NavItem;
  profile: NavItem;
  IconUser = IoniconsOutline.user;

  IconProfile = IoniconsOutline.userCircle;
  IconLogOut = IoniconsOutline.logout;

  username?: string;
  name?: string;
  surname?: string;
  email?: string;
  orgName?: string;
  admin = false;
  system = false;

  constructor(
    private store: Store,
    private localStorageService: LocalStorageService,
    public translate: TranslateService
  ) {}

  ngOnChanges(): void {
    this.organization$
      .pipe(untilDestroyed(this))
      .subscribe((org: Organization) => {
        this.org = {
          ...org,
          logo: undefined,
          pdfLogo: undefined,
          resellerLogo: undefined,
          css: undefined,
        };
        this.orgName = this.org.name;
      });

    this.user$.pipe(untilDestroyed(this)).subscribe((user: LoggedUser) => {
      this.user = user;
      if (this.user) {
        this.username = user.username;
        this.name = user.name;
        this.surname = user.surname;
        this.email = user.email;
        this.admin = false;
        this.system = user.system;
      } else {
        this.username = undefined;
        this.name = undefined;
        this.surname = undefined;
        this.email = undefined;
        this.admin = undefined;
        this.system = undefined;
      }
    });
  }

  ngOnInit(): void {
    if (this.isValidInput()) {
      this.signOut = this.item.children.find(
        (item) => item.id === NavItemsId.SIGNOUT
      );
      this.profile = this.item.children.find(
        (item) => item.id === NavItemsId.PROFILE
      );
      this.user$ = this.item.data;
    }
  }

  clickItem(item: NavItem) {
    if (item?.routerLink) {
      this.store.dispatch(
        PtCoreActions.navigateTo({
          route: [item?.routerLink],
        })
      );
    }
  }

  clickSignOut(item: NavItem) {
    // Questo è l'unico caso in cui uso questo metodo
    this.localStorageService.clearLatestPage();
    this.store.dispatch(
      PtCoreActions.logoutAndClearData({
        route: [item?.routerLink],
        domain: UrlUtils.getDomainIfExists(),
      })
    );
  }

  private isValidInput(): boolean {
    const profile = this.item.children.find(
      (item) => item.id === NavItemsId.PROFILE
    );
    const signout = this.item.children.find(
      (item) => item.id === NavItemsId.SIGNOUT
    );
    if (profile === undefined && signout === undefined) {
      console.warn(
        'NavUser Item require at least PROFILE or SIGNOUT children element'
      );
      return false;
    }
    return true;
  }
}
